import { geturi } from 'libs/utils';
import Vue from 'vue';

export const useHttp2 = () => (performance.getEntriesByType('navigation')[0].nextHopProtocol === 'h2');

export const createListener = (eventStream, fallBack, interval = 30000) => {
  return useHttp2() ? new EventStreamNotificationListener(eventStream) : new PollNotificationListener(fallBack, interval);
};

class BaseNotificationListener {
  constructor() {
    this.Bus = new Vue();
  }
  /**
   * On message handler
   * @param {MessageEvent} e 
   */
  onMessage (e) {
    try {
      let json = JSON.parse(e.data);
      if (json) {
        this.processEvent(json);
      }
    } catch (error) {
      console.error('Error parsing message', error);
    }
  }
  /**
   * @param {Event} args 
   */
  onError (args) {
    console.error(args);
    this.es.close();
  }
  processEvent (eventwrapper) {
    let type = eventwrapper.EventType;
    let data = eventwrapper.EventData;
    this.Bus.$emit(type, data);
  }
}

export class PollNotificationListener extends BaseNotificationListener {
  constructor(getDataMethod, interval = 30000) {
    super();
    this.i = 0;
    this.interId = window.setInterval(() => this.refresh(), interval);
    this.getDataMethod = getDataMethod;
    this.date = null;
    this.refresh();
  }
  async refresh() {
    this.i += 1;
    try {
      let current = this.date;
      let results = await this.getDataMethod(current);
      if (results) {
        this.date = results.LastReceived;
        this.processEvent(results);
      }
    } catch (error) {
      console.error('Stopping - Error: ', error);
      window.clearInterval(this.interId);
    }
    if (this.i > 10) {
      // max 10 iterations
      window.clearInterval(this.interId);
    }
  }
}

export class EventStreamNotificationListener extends BaseNotificationListener {
  constructor(source) {
    super();
    var uri = geturi(source);
    this.listeners = [];
    this.es = new EventSource(uri);
    this.es.onmessage = (e) => this.onMessage(e);
    this.es.onerror = (e) => this.onError(e);
  }
  close(){
    if(this.es){
      this.es.close();
    }
  }

}